import { type DefaultQueryError, httpClient } from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type {
  DefaultOpsTechResponse,
  DefaultPagingParams,
  LocaleContent,
} from '../types';
import apiRoutes from '@/lib/api-routes';

export interface RewardSession {
  id: number;
  status: number;
  created_time: Date;
  updated_time: Date;
  name: LocaleContent;
}

export const getRewardSessionFn = async (
  params: Partial<DefaultPagingParams>
) => {
  const response = await httpClient.get<
    DefaultOpsTechResponse<RewardSession[]>
  >(apiRoutes.rewards.session, {
    params,
  });
  return response.data.data;
};

export const useGetRewardSession = (
  params: Partial<DefaultPagingParams>,
  opts?: UseQueryOptions<RewardSession[], DefaultQueryError>
) =>
  useQuery<RewardSession[], DefaultQueryError>({
    queryKey: [apiRoutes.rewards.session, params],
    queryFn: () => getRewardSessionFn(params),
    ...opts,
  });

export const getRewardSessionDetailFn = async (id: RewardSession['id']) => {
  const response = await httpClient.get<DefaultOpsTechResponse<RewardSession>>(
    apiRoutes.rewards.sessionDetail(id)
  );
  return response.data.data;
};

export const useGetRewardSessionDetail = (
  id: RewardSession['id'],
  opts?: UseQueryOptions<RewardSession, DefaultQueryError>
) =>
  useQuery<RewardSession, DefaultQueryError>({
    queryKey: [apiRoutes.rewards.sessionDetail(id)],
    queryFn: () => getRewardSessionDetailFn(id),
    ...opts,
  });
